import React from 'react';
import { format } from 'date-fns';

interface Message {
  id: string;
  sender: string;
  content: string;
  timestamp: string;
  isRead: boolean;
  avatar?: string;
  isInfluencer?: boolean;
}

interface MessageListProps {
  messages: Message[];
  selectedMessageId: string | null;
  onMessageSelect: (messageId: string) => void;
}

export default function MessageList({ messages, selectedMessageId, onMessageSelect }: MessageListProps) {
  return (
    <div className="h-full overflow-y-auto">
      {messages.map((message) => (
        <div
          key={message.id}
          onClick={() => onMessageSelect(message.id)}
          className={`p-4 border-b border-gray-100 cursor-pointer transition-colors ${
            selectedMessageId === message.id ? 'bg-primary-50' : 'hover:bg-gray-50'
          }`}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-3">
              {message.isInfluencer ? (
                <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-purple-600 to-pink-500 p-2">
                  <svg viewBox="0 0 24 24" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </div>
              ) : (
                <img
                  src={message.avatar}
                  alt=""
                  className="w-10 h-10 rounded-full bg-gray-200 object-cover"
                />
              )}
              <div>
                <h3 className="text-sm font-medium text-gray-900">@{message.sender}</h3>
                <p className="text-sm text-gray-500 line-clamp-1">{message.content}</p>
              </div>
            </div>
            <div className="flex flex-col items-end space-y-1">
              <span className="text-xs text-gray-500">
                {format(new Date(message.timestamp), 'MMM d, h:mm a')}
              </span>
              {!message.isRead && (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
                  New
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}